import "./inverterDatasheet2.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";
import { inverterInformation } from "../../DataFiles/inverterInformation";

const InverterDatasheet2 = (props) => {
  const { tableContent, indexValue } = props;
  const pageDetail = tableContent.find(
    (item) => item.title === "Product Data Sheets"
  );
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData[roofIndex];
  let inverterInfo = [];

  if (quantityInfo.electricalConfiguration === "All Roof") {
    inverterInfo = roofInfo.value.inverterAnalysis;
  } else {
    inverterInfo = roofDetail.inverterAnalysis;
  }

  let inverterBrand = inverterInformation.find(
    (item) =>
      item.brand === inverterInfo.inverterManufacturer &&
      item.phase === inverterInfo.inverterPhase &&
      item.systemType === inverterInfo.systemType
  );
  let inverterDetail =
    inverterInfo.inverterType !== "Select"
      ? inverterBrand.inverterType.find(
          (item) => item.name === inverterInfo.inverterType
        )
      : [];

  let pageIndex =
    tableContent[tableContent.length - 1].pageNo - indexValue * 2 - 1;

  return (
    <div id="inverter-datasheet-two" className="inverter-datasheet-two">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="id2-body">
        <p>Inverter</p>
        <img
          className="img"
          src={inverterDetail.dataSheet2}
          alt="Inverter"
        ></img>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageIndex : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default InverterDatasheet2;
